// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2euKw","title":"FrontImage_title__3r1gy"};